import type { ReactNode } from 'react'
import { cn } from '../lib/utils'
import { SectionHeader } from './SectionHeader'

export function Section({
  title,
  subtitle,
  action,
  loading,
  testId,
  className,
  children,
}: {
  title?: ReactNode
  /** One muted line under the heading saying what the section is for. */
  subtitle?: ReactNode
  action?: ReactNode
  loading?: boolean
  testId?: string
  className?: string
  children: ReactNode
}) {
  return (
    <section className={cn('space-y-1', className)} data-testid={testId}>
      {(title || loading || action) && <SectionHeader action={action} loading={loading}>{title}</SectionHeader>}
      {subtitle && !loading && <p className="-mt-1 pb-1 text-xs text-muted-foreground">{subtitle}</p>}
      <div className="flex flex-col gap-3">
        {children}
      </div>
    </section>
  )
}
